import { Box } from "@mui/material";
import { AppCircularProgress } from "./Components/Progress/AppCircularProgress";
import { useExternalSso } from "./Hooks/Home";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import qs from "qs";

export const SSO = () => {
    const location = useLocation();
    useEffect(() => {
        const parsedQueryString = qs.parse(location.search, {
            ignoreQueryPrefix: true,
        });

        const { accessToken, memberId } = parsedQueryString;
        fetch(accessToken.toString(), memberId.toString());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location?.search]);
    const { fetch } = useExternalSso();
    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            height="100dvh"
        >
            <AppCircularProgress />
        </Box>
    );
};
